import React, { Component } from 'react';

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Detail from "./Detail.js"
import Delete from "./Delete.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Subgrupos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "pk",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Grupo",
                    id: "padre__nombre",
                    accessor: d => d.padre__nombre,
                    show: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Abreviatura",
                    id: "abreviatura",
                    accessor: d => d.abreviatura,
                    show: true,
                },
                {
                    Header: "Teléfono",
                    id: "telefono",
                    accessor: d => d.telefono,
                    show: true,
                },
                {
                    Header: "Email",
                    id: "mail",
                    accessor: d => d.mail,
                    show: true,
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        component: Create,
                        permission: 'subgrupos_add',
                    },
                    {
                        detail: true,
                        component: Detail,
                        permission: 'subgrupos_detail',   
                    },
                    {
                        edit:true,
                        component: Edit,
                        permission: 'subgrupos_edit',
                    },
                    {
                        edit:true,
                        component: Delete,
                        permission: 'subgrupos_delete',
                    }
                ]}
                apiUrl={api.usuarios.subgrupos.list}
                columns={this.state.columns}
                exportUrl={api.usuarios.subgrupos.export}
                title={"Subgrupos"}
            />
        );
    }
}

export default Subgrupos;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Subgrupos/Subgrupos.js